import { render, staticRenderFns } from "./AvailableColorsTabs.vue?vue&type=template&id=27cea624&scoped=true"
import script from "./AvailableColorsTabs.vue?vue&type=script&lang=js"
export * from "./AvailableColorsTabs.vue?vue&type=script&lang=js"
import style0 from "./AvailableColorsTabs.vue?vue&type=style&index=0&id=27cea624&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27cea624",
  null
  
)

export default component.exports